<script>
import { ref, defineComponent } from 'vue'
//feature
// import { useModal } from '@/feature/ModalFeature';
// import { useErrorApi } from '@/feature/ErrorApiFeature'
// import { useAuthStatus } from '@/feature/AuthStatusFeature'
import { useLandingFlow } from '../../feature/LandingFlowFeature'
//component
import CampaignItem from "./CampaignItem.vue";
//service
import Topup2c2pService from '../../service/Topup2c2pService';


/**
 * @event onLoaded
 */
export default defineComponent({
    components: {
        CampaignItem,
    },
    props: {
        initListConfig:     { type: Object, required: true },
        initFilterConfig: { type: Object, required: true },
        header: { type: String, default: ''}
    },
    emits: ['update:inputValue','onLoaded'],
    expose: ['loadMore','reinitList'],
    setup: (props, ctx) => {
        // const { errorApi } = useErrorApi()
        // const modal = useModal()
        let listConfig = ref(null)
        let filterConfig = ref(null)
        let campaignsList = ref([])
        let isLoading = ref(false)
        let isLoaded = ref(false)
        let isHaveItem = ref(false)
        // const { token } = useAuthStatus()
        const { query,blobWebLanding } = useLandingFlow()
        //#region methods
        const getList = () => {
            //modal.loadingModal.show();
            return new Promise((resolve) => {
                isLoading.value = true
                Topup2c2pService.apiGetCampaign(query.value.token, listConfig.value, filterConfig.value, query.value.appId , blobWebLanding.value, query.value.jwt).subscribe({
                    next: (campaigns) => {
                        listConfig.value.intSkip += listConfig.value.defaultTopAmount;
                        //check is there are more campaign.
                        if (campaigns && campaigns.length < listConfig.value.defaultTopAmount) {
                            listConfig.value.isSeeMoreEnable = false
                        }

                        //reinitialize list if no skip.
                        if (listConfig.value.intSkip == listConfig.value.defaultTopAmount) {
                            console.log('not have campaign')
                            campaignsList.value = []
                        }

                        for (var campaign of campaigns) {
                            //TODO: Add GA Tracking.
                            campaignsList.value.push(campaign)
                            console.log('have campaign')
                        }

                        isLoading.value = false
                        isLoaded.value = true
                        isHaveItem.value = campaignsList.value.length > 0
                            ? true
                            : false


                        console.log('campaignsList', campaignsList.value)
                        if (campaignsList.value.length > 0) {
                            ctx.emit('onUpdateCate', campaignsList.value[0]?.categoryName)
                        }
                        resolve()
                        ctx.emit('onLoaded')
                        
                    },
                    error: (err) => {
                        console.log(err)
                        isLoading.value = false
                        isLoaded.value = true
                        isHaveItem.value = false
                        listConfig.value.isSeeMoreEnable = false
                        //modal.loadingModal.hide()
                        //errorApi(err)

                        ctx.emit('onLoaded')
                        resolve()
                    },
                });
            });
        }

        const reinitList = (paramslistConfig, paramslistFilter) => {
            listConfig.value = paramslistConfig;
            filterConfig.value = paramslistFilter;
            campaignsList.value = [];
            getList();
        }

        const loadMore = async () =>  {
            console.log('load more list', listConfig.value.isSeeMoreEnable);
            if (!listConfig.value.isSeeMoreEnable || isLoading.value) {
                return;
            }

            //modal.loadingModal.show();
            await getList();
            //modal.loadingModal.hide();
        }

        


        const setConfig = () => {
            listConfig.value = props.initListConfig
            filterConfig.value = props.initFilterConfig
        }
        //#endregion methods

        //#region init
        setConfig()
        getList()
        //#endregion init
        return {
            campaignsList,
            isLoaded,
            isHaveItem,

            loadMore,
            reinitList,
        }

    }
})
</script>
<template>
    <div class="bg-white px-5 py-4">
        <div class="text-14 pb-4 text-a-gray-4a4a4a">{{header}}</div>
        <div class="grid grid-cols-2 gap-4">
            <CampaignItem
                    v-for="(campaign) in campaignsList"
                    :key="campaign.id"
                    :campaign="campaign"
            ></CampaignItem>

            <div v-if="isLoaded && !isHaveItem">
                Not Found
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
</style>
